import { useContext } from "react";
import { TimeTrackingContext } from "@/contexts/TimeTrackingContextTypes";

export function useTimeTrackingContext() {
  const context = useContext(TimeTrackingContext);
  if (context === undefined) {
    throw new Error(
      "useTimeTrackingContext must be used within a TimeTrackingProvider"
    );
  }
  return context;
}
